import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import HouseholdInfoSectionClient from './HouseholdInfoSectionClient';

const HouseholdInfoSectionClients = ({ collection }) => {
  return (
    <>
      {collection.resources().list().map((resource) => (
        <FDBox key={resource.id()} flex={1}>
          <HouseholdInfoSectionClient resource={resource} />
        </FDBox>
      ))}
    </>
  );
};

HouseholdInfoSectionClients.propTypes = {
  collection: PropTypes.object.isRequired,
};

HouseholdInfoSectionClients.defaultProps = {};

export default HouseholdInfoSectionClients;
